<template>
  <div class="mobile-company-box" ref="companyBox">
    <div
      class="mobile-company-item"
      v-for="(item, index) in itemList"
      :key="index"
      :class="{
        [`mobile-bg${index + 1}`]: true,
        'mobile-active': isActive(index),
      }"
      :ref="`item${index}`"
      @click="handleClick(index)"
    >
      <div class="mobile-content">
        <div class="mobile-title">{{ item.title }}</div>
        <div class="mobile-text">
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemList: [
        {
          title: "客户至上",
          text: "以客户需求为核心，提供优质解决方案，助力客户成功。",
        },
        {
          title: "创新驱动",
          text: "持续探索突破，以创新思维引领行业发展。",
        },
        {
          title: "使命必达",
          text: "坚守责任，执行，以专业精神确保目标高效实现。",
        },
        {
          title: "协作共赢",
          text: "团队同心，共享价值，与参与者共同创造辉煌。",
        },
        {
          title: "成长无限",
          text: "自我主动学习，勇于挑战， 不断超越，实现共同成长。",
        },
      ],
      scrollTop: 0,
      viewportHeight: 0,
      itemPositions: [],
      activeIndex: 0,
    };
  },
  mounted() {
    this.viewportHeight = window.innerHeight;
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    this.$nextTick(() => {
      this.updateItemPositions();
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.scrollY;
      this.updateActiveIndex();
    },
    handleResize() {
      this.viewportHeight = window.innerHeight;
      this.updateItemPositions();
      this.updateActiveIndex();
    },
    updateItemPositions() {
      this.itemPositions = this.itemList.map((_, index) => {
        const el = this.$refs[`item${index}`][0];
        if (el) {
          const rect = el.getBoundingClientRect();
          return {
            top: rect.top + window.scrollY,
            height: rect.height,
          };
        }
        return { top: 0, height: 0 };
      });
    },
    updateActiveIndex() {
      let minDistance = Infinity;
      let newActiveIndex = 0;

      this.itemPositions.forEach((item, index) => {
        if (!item) return;

        const viewportMiddle = this.scrollTop + this.viewportHeight / 2;
        const itemMiddle = item.top + item.height / 2;
        const distance = Math.abs(viewportMiddle - itemMiddle);

        if (distance < minDistance) {
          minDistance = distance;
          newActiveIndex = index;
        }
      });

      this.activeIndex = newActiveIndex;
    },
    handleClick(index) {
      this.activeIndex = index;
    },
    isActive(index) {
      return this.activeIndex === index;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
